import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Loader } from 'semantic-ui-react';
import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import AnalyticsPlaceholder from 'components/dashboard/analytics-content/AnalyticsPlaceholder';
import ChartItem from 'components/dashboard/analytics-content/AnalyticsActivityCharts/ChartItem';

import './EarningPerDayGraph.css';

const EarningPerDayGraph = ({
  graphDailyEarning,
}) => {
  const { t } = useTranslation();
  const [isGraphDailyEarning, setGraphDailyEarning] = useState({});

  useEffect(() => {
    if (graphDailyEarning) {
      setGraphDailyEarning(graphDailyEarning);
    }
    return () => setGraphDailyEarning({});
  }, [graphDailyEarning]);

  if (isGraphDailyEarning && Object.keys(isGraphDailyEarning).length === 0) {
    return <AnalyticsPlaceholder title={t("Earning per Day")} text={t("Looks like you have no data to display yet…")} />;
  }

  const renderChartData = () => {
    if (!isGraphDailyEarning || isGraphDailyEarning && Object.keys(isGraphDailyEarning).length === 0) {
      return null;
    }
    return (
      <ChartItem
        compact
        chartData={isGraphDailyEarning.chartData}
        color="41, 117, 207"
        header=""
        type="earn"
        totalData={isGraphDailyEarning.series.reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)}
        labelPrefix="$"
        labelPosition="left"
        valuePrefix="$"
        roundValuesTo={2}
      />
    );
  };

  return (
    <AnalyticsSection
      className="earnings-per-day-graph__component"
      header={
        <div className="title">
          <h3>{t("Earning per Day")}</h3>
        </div>
      }
    >
      {renderChartData()}
      <Loader active={!graphDailyEarning} />
    </AnalyticsSection>
  );
};

EarningPerDayGraph.propTypes = {
  graphDailyEarning: PropTypes.object,
};
EarningPerDayGraph.defaultProps = {
  graphDailyEarning: {},
};

export default EarningPerDayGraph;
